module.exports = __webpack_public_path__ + "img/50.87c88516.jpg";